import React from 'react';
import {DropzoneState} from 'react-dropzone';
import classnames from '../../../src/helpers/classnames';
import Translate from '../../../src/components/Translate/Translate';

export default function DropZone(props: {
    className?: string,
    children: React.ReactNode,
    size?: 'sm',
    plain?: boolean,
    tabIndex?: number,
} & Pick<DropzoneState, 'isDragActive' | 'getRootProps' | 'getInputProps'>) {
    return <div
            className={classnames(props.className, 'chat__dropzone', {
                'chat__dropzone--sm': props.size === 'sm',
                'chat__dropzone--plain': props.plain,
            })}
            {...props.getRootProps({tabIndex: props.tabIndex})}
    >
        <input {...props.getInputProps({multiple: true})}/>

        {!props.isDragActive ? null : (
                <div className={classnames('chat__dropzone__drop-file-here-message', {
                    'chat__dropzone__drop-file-here-message--visible': props.isDragActive,
                })}>
                    <Translate message="Chat:MessageReceiver.drop-file-here"/>
                </div>
        )}

        {props.children}
    </div>;
}
